// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"277":"b465a5c3b8f41ca5","2888":"4757d02db3b45087"}[chunkId] + ".css";
};